module.exports = __webpack_public_path__ + "static/media/rd-center-02.db57c1c9.png";